module.exports = __webpack_public_path__ + "img/missing_paper_towel.3b60aec3.svg";